import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Loader } from '@itds/elements/index.js';
import { CarrierCard } from '@itds/components/index.js';

import { Api } from '@brokerage/utils/Api';

const LimitCarriers = ({ mobile_app, updateAgencyMobileApp }) => {
  const [data, setData] = useState({
    annuity_carrier_ids: mobile_app.annuity_carrier_ids || [],
    annuity_product_ids: mobile_app.annuity_product_ids || []
  });
  const [product_ids, setProductIds] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [carrier_ids, setCarrierIds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  useEffect(() => {
    setData({
      annuity_carrier_ids: mobile_app.annuity_carrier_ids || [],
      annuity_product_ids: mobile_app.annuity_product_ids || []
    });
  }, [mobile_app]);

  const getData = () => {
    Api.loadAnnuityCarriers().then(response => {
      const carriers = response.data;

      setCarriers(carriers);
      setCarrierIds(carriers.map(c => c.id));
      setProductIds(carriers.map(c => c.products.map(p => p.id)).flat());
      setLoading(false);
    });
  };

  const handleSelectAll = () => {
    if (data.annuity_carrier_ids.length !== carrier_ids.length) {
      setData({
        annuity_carrier_ids: carrier_ids,
        annuity_product_ids: product_ids
      });
    } else {
      setData({ annuity_carrier_ids: [], annuity_product_ids: [] });
    }
  };

  const handleCarrierToggle = (carrier, checked) => {
    const is_selected = !checked;
    const carrier_product_ids = carrier.products.map(p => p.id);

    let selected_carrier_ids = [...data.annuity_carrier_ids];

    let selected_product_ids = [...data.annuity_product_ids];

    if (is_selected) {
      selected_carrier_ids.push(carrier.id);
      selected_product_ids = data.annuity_product_ids.concat(carrier_product_ids);
    } else {
      selected_carrier_ids = data.annuity_carrier_ids.filter(id => id !== carrier.id);
      selected_product_ids = data.annuity_product_ids.filter(
        id => !carrier_product_ids.includes(id)
      );
    }

    setData({
      annuity_carrier_ids: selected_carrier_ids,
      annuity_product_ids: selected_product_ids
    });
  };

  const handleProductsChange = (carrier, p_ids) => {
    const carrier_product_ids = carrier.products.map(p => p.id);
    const other_product_ids = data.annuity_product_ids.filter(
      id => !carrier_product_ids.includes(id)
    );

    setData({
      annuity_carrier_ids: data.annuity_carrier_ids,
      annuity_product_ids: [...other_product_ids, ...p_ids]
    });
  };

  const save = () => {
    updateAgencyMobileApp(data);
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <div style={{ marginBottom: '30px' }}>
        <Button inline={true} onClick={handleSelectAll.bind(null)} small={true}>
          {data.annuity_carrier_ids.length === carrier_ids.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {carriers.map(carrier => {
              const is_selected = data.annuity_carrier_ids.includes(carrier.id);

              return (
                <CarrierCard
                  carrier={carrier}
                  isSelected={is_selected}
                  key={carrier.id}
                  lineOfBusiness='annuities'
                  onClick={handleCarrierToggle.bind(null, carrier, is_selected)}
                  onProductsSave={handleProductsChange.bind(null, carrier)}
                  products={carrier.products}
                  selectedProductIds={data.annuity_product_ids}
                />
              );
            })}
          </div>
          <Button inline={true} onClick={save.bind(null, data)}>
            Save Changes
          </Button>
        </>
      )}
    </>
  );
};

LimitCarriers.propTypes = {
  mobile_app: PropTypes.object
};

export default LimitCarriers;
